import { render } from "./RicercaMoto.vue?vue&type=template&id=91cd66bc"
import script from "./RicercaMoto.vue?vue&type=script&lang=js"
export * from "./RicercaMoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__